import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mensagem',
  templateUrl: './mensagem.component.html',
  styles: []
})
//$Id$
export class MensagemComponent implements OnInit {
  @Input() texto:string =  ''
  @Input() isValueInvalid:boolean;
  messagem = '';


  constructor() { }

  ngOnInit() {
      if(this.isValueInvalid){
          this.messagem = '* Valor inválido';
      }else{
         this.messagem = this.texto;
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/mensagem/mensagem.component.ts